<template>
    <!-- Loading -->
    <div class="vld-parent">
        <loading v-model:active="isLoading" :is-full-page="true" :height="128" :width="128" />
    </div>

    <form @submit.prevent="store" class="form-content">
        <div class="form-content-inner">
            <div class="form-col">
                <control type="hidden" v-model="retirement.id" :hasError="!!errors.id" id="id"/>
            </div>

            <div class="form-col">
                <field :label="$t('academicyear.date')" class="w-full md:w-2/2 px-3 mb-6 md:mb-0">
                    <datepicker v-model="retirement.date" :enableTimePicker="false" name="date_end" :auto-apply="true"></datepicker>
                </field>
            </div>

            <div class="form-col">
                <field :label="$t('vaccines.description')" class="w-full md:w-2/2 px-3 mb-6 md:mb-0">
                    <control type="text" :placeholder="$t('vaccines.placeholder.description')" v-model="retirement.remarks"/>
                </field>
            </div>

            <div class="buttons-submit transition-colors duration-1000" :class="darkMode ? 'bg-darkmode-base' : 'bg-gray-100'">
                <jb-buttons class="buttons-action-submit">
                    <jb-button type="submit" color="info" :icon="mdiCheckBold" :label="$t('finance.button.btnSubmit')" class="form-submit-btn" />
                    <jb-button type="button" color="info" outline :label="$t('finance.button.btnReset')" class="form-noicon-btn btn-reset" @click="reset()" />
                </jb-buttons>
            </div>
        </div>
    </form>
</template>
<script>
/* eslint-disable */
import { ref, reactive, onMounted, onBeforeMount, watch, watchEffect } from 'vue'
import axios from 'axios'
import { mdiBallot, mdiCheckBold } from '@mdi/js'
import { useStore } from 'vuex'
import Control from '@/components/Control'
import { useRouter } from 'vue-router'
import JbButton from '@/components/JbButton'
import JbButtons from '@/components/JbButtons'
import Field from '@/components/Field'
import { useToast } from 'vue-toastification'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main\.css'
import Loading from 'vue-loading-overlay'
export default {
    name: 'ClassForm',
    components: {
        Field,
        Datepicker,
        Control,
        JbButton,
        JbButtons,
        Loading
    },
    props: {
        showEdit: { Boolean },
        propClass: {
            type: Object,
            default: () => ({ empty: true })
        },
        propObject: {
            type: Object,
            default: () => ({ empty: true })
        }
    },
    data: function () {
        return {
        }
    },
    emits: ['close-modal', 'submit', 'refresh-list'],
    setup (props, { emit }) {
        const titleStack = ref(['Admin', 'Forms'])
        const isLoading = ref(false)

        const toast = useToast()

        const router = useRouter()

        const errors = ref([])
        const options = ['ID Card', 'Family Card', 'Passport', 'TIN']
        const preview = ref('')

        const str = useStore()
        const userlogin = localStorage.getItem('name')

        const retirement = reactive({
            id: '',
            date: '',
            remarks: '',
            created_by: '',
            updated_by: ''
        })

        const customElementsForm = reactive({
            checkbox: ['lorem'],
            radio: 'one',
            is_active: [1],
            file: null
        })

        const onFileChange = async (event, evt) => {
            const file = event.target.files[0]
            if (file) {
                if (file.size > 1024 * 1024) {
                    alert('File too big (> 1MB)')
                    file.value = ''
                } else {
                    const reader = new FileReader()
                    reader.onloadend = function () {
                        preview.value = reader.result
                }
                reader.readAsDataURL(file)
                }
            } else {
                preview.value = ''
            }
        }

        const store = async () => {
            isLoading.value = true
            const url = props.showEdit ? 'retirement/' + retirement.id : 'retirement';
            const method = props.showEdit ? "PUT" : "POST";
            retirement.created_by = userlogin
            await axios({
                    method,
                    url,
                    params: retirement
                })
                .then(response => {
                    if (response.data.success) {
                        emit('close-modal')
                        emit('refresh-list')
                        toast.success(response.data.message)
                    } else {
                        errors.value = response.data.messages
                        toast.error(response.data.messages)
                    }
                    isLoading.value = false
                })
                .catch(error => {
                    if (error.response) {
                        console.log(error)
                        toast.error(error.response.data.message)
                        console.log(JSON.stringify(error.request))
                    } else if (error.message) {
                        console.log(error.message)
                        toast.error(error.message)
                        console.log(JSON.stringify(error.message))
                    }
                    isLoading.value = false
                })
        }

        onBeforeMount(() => {
        })

        onMounted(() => {
            // retirement.value =toRefs(props, 'propClass')
        })

        watch(() => props.propClass, (newVal, oldVal) => {
            retirement.file = ''
            retirement.description = ''
        })

        watchEffect(() => {
            const newobject = props.propObject;
            Object.assign(retirement, newobject);

            if (!props.showEdit) {
                retirement.id = null;
                retirement.date = null;
                retirement.remarks = null;
            }

            const newretirement = props.propClass
            retirement.submenu = newretirement.submenu
            retirement.ein = newretirement.ein
            retirement.employee_id = newretirement.employee_id
        })

        return {
            titleStack,
            onFileChange,
            customElementsForm,
            mdiBallot,
            mdiCheckBold,
            options,
            router,
            retirement,
            store,
            toast,
            userlogin,
            errors,
            isLoading
        }
    },
    methods: {
        // async store () {
        //     const dataForm = {
        //         id: this.retirement.id,
        //         name: this.retirement.name,
        //         academic_year_id: this.retirement.academic_year_id,
        //         capacity: this.retirement.capacity,
        //         homeroom_id: this.retirement.homeroom_id ?? this.retirement.level_id,
        //         is_active: this.customElementsForm.is_active ?? false,
        //         remarks: this.retirement.remarks,
        //         level_id: this.retirement.level_id,
        //         department_id: this.retirement.department_id,
        //         remarks1: this.retirement.remarks1,
        //         remarks2: this.retirement.remarks2,
        //         remarks3: this.retirement.remarks3,
        //         created_by: 'admin',
        //         updated_by: this.retirement.updated_by
        //     }
        //     // await axios
        //     //     .post('class', dataForm)
        //     //     .then(response => {
        //     //         if (response.data.success) {
        //     //         } else {
        //     //             this.errors = response.data.messages
        //     //         }
        //     //     })
        //     //     .catch(error => {
        //     //         if (error.response) {
        //     //             console.log(error)
        //     //             console.log(JSON.stringify(error.request))
        //     //         } else if (error.message) {
        //     //             console.log(error.message)
        //     //             console.log(JSON.stringify(error.message))
        //     //         }
        //     //     })
        // },
        clearForm () {
            this.retirement = reactive({
                id: '',
                description: '',
                created_by: ''
            })
        },
        onChange: function (department_id, event) {
            if (event.target.value) {
                department_id = event.target.value
            }
            this.levelListFilter = this.levelList.filter(item => item.department_id === department_id)
            this.academicYearListFilter = this.academicYearList.filter(item => item.department_id === department_id)
        }
    },
    created () {
        this.levelListFilter = this.levelList
        this.academicYearListFilter = this.academicYearList
    }
}
</script>
